import pickBy from "lodash/pickBy";
import identity from "lodash/identity";

/**
 * Fetch data from the server
 * @param {string} url - The url to fetch data from
 * @param {Object} options - The options for the fetch request
 * @returns {Promise<Object>} The data from the server
 */
async function fetcher(url, options = {}) {
  // Extract headers and rest options
  const { headers: headersOptions, ...restOptions } = options;

  // Initialize headers
  const headers = new Headers(headersOptions);

  // Add auth cookie to the request
  if (typeof window === "undefined") {
    await import("next/headers").then(async ({ cookies }) => {
      const cookiesStore = await cookies();
      const authApiToken = cookiesStore.get("apiToken")?.value;

      if (authApiToken) {
        headers.set("Authorization", `Bearer ${authApiToken}`);
      }
    });
  } else {
    await import("cookies-next/client").then(({ getCookie }) => {
      const authApiToken = getCookie("apiToken");

      if (authApiToken) {
        headers.set("Authorization", `Bearer ${authApiToken}`);
      }
    });
  }

  // Add auth cookie to the request
  if (options.requiredAuthCookie) {
    const authApiToken = getCookie("apiToken");

    if (!authApiToken) {
      throw new Error("Unauthorized");
    }
  }

  // Add query params to the url
  const finalUrl = new URL(`${process.env.NEXT_PUBLIC_FRONTEND_DOMAIN}${url}`);

  // Add query params to the url
  if (options.params) {
    const queryString = new URLSearchParams(pickBy(options.params, identity));
    finalUrl.search = queryString.toString();
  }

  if (!headers.get("content-type") && !(options.body instanceof FormData)) {
    headers.append("Content-Type", "application/json");
  }

  headers.set("Platform", "WEB");

  // Add headers to the request
  if (!url.startsWith("/api/web")) {
    headers.set("token", process.env.NEXT_PUBLIC_JAVA_API_TOKEN);
  }

  // Fetch the data
  return fetch(finalUrl, {
    method: "GET",
    headers,
    ...restOptions,
  });
}

export default fetcher;
